import axios from "axios";
import { awsUrl, aspNetUrl, newApiBaseUrl } from "../../axiosInstance";
import * as actionType from "../store/action";
import showAlert from "./ShowAlert";
import { setPreload } from "./CartsOpen";
import { setBaseProducts } from "./ProductsFilters";

export const reloadFunc = () => ({
  type: "RELOAD_SALES_START",
});

export const reloedFunc = () => (dispatch) =>
  dispatch({ type: actionType.RELOED });

export const createProduct = (data) => {
  return axios.post(`${awsUrl}/v1/products`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.jwtToken}`,
    },
  });
};

export const getOrphanProducts = () => {
  return (dispatch) => {
    axios
      .get(`${awsUrl}/v1/products/category/orphan`, {
        headers: {
          Authorization: `bearer ${localStorage.jwtToken}`,
        },
      })
      .then((x) => {
        dispatch({
          type: actionType.SET_PRODUCTS,
          payload: {
            items: x.data,
          },
        });
      })
      .catch((e) => console.log(e));
  };
};

let salesController = null;

export const getSales = (stationId, isClientView) => async (dispatch) => {
  if (salesController) {
    salesController.abort();
  }
  salesController = new AbortController();
  const { signal } = salesController;

  try {
    const { data: promotions } = await axios.get(
      `${newApiBaseUrl}/promotions`,
      {
        signal,
        params: { branch: stationId },
        headers: {
          Authorization: `bearer ${localStorage.jwtToken}`,
          "X-Tenant": "hamazon",
        },
      },
    );
    const promosArray = Array.isArray(promotions) ? promotions : [];
    const gtinsList = [
      ...new Set(promosArray.map((p) => p.gtin).filter((g) => g)),
    ];

    if (!gtinsList.length) {
      return dispatch({
        type: actionType.SET_PRODUCTS,
        payload: { items: [] },
      });
    }

    const productIdsString = gtinsList.map((g) => `${g}-000`).join(",");

    console.log(isClientView);
    const { data: rawProducts } = await axios.get(
      `${newApiBaseUrl}/admin/products`,
      {
        signal,
        params: {
          branch: stationId,
          productIds: productIdsString,
          fields:
            "gtin,name,variant,status,brand,sub_brand,user_company,media,description,kosher_supervision,weight_details,weight_jump,view_brand",
          isClientView: isClientView ? true : false,
        },
        headers: {
          Authorization: `bearer ${localStorage.jwtToken}`,
          "X-Tenant": "hamazon",
        },
      },
    );

    const items = Array.isArray(rawProducts) ? rawProducts : [];

    dispatch({
      type: actionType.SET_PRODUCTS,
      payload: { items: { products: items, isFamily: false } },
    });

    return { data: promosArray };
  } catch (e) {
    console.error("Failed to fetch products:", e);
    if (axios.isCancel(e)) return;
    dispatch({ type: actionType.SET_PRODUCTS, payload: { items: [] } });
  } finally {
    salesController = null;
  }
};
export const getByMkt = (mkt, stationId) => {
  return (dispatch) => {
    axios
      .get(`${awsUrl}/v1/products/${mkt}`, {
        headers: {
          Authorization: `bearer ${localStorage.jwtToken}`,
        },
      })
      .then((x) =>
        dispatch({ type: actionType.SET_SELCTED_PRODUCT, data: x.data }),
      )
      .catch(() => console.log("error"));
  };
};

export const getItemsPerCategoryCount = (id, stationId, count, mkt) => {
  return axios.get(
    `${awsUrl}/v1/products/${mkt}/category/${id}/count?stationId=${stationId}&count=${count}`,
    {
      headers: {
        Authorization: `bearer ${localStorage.jwtToken}`,
      },
    },
  );
};
export const getItemsPerCategory = (slug, stationId) => {
  return axios.get(`${newApiBaseUrl}/categories/${slug}/products`, {
    params: {
      branch: stationId,
    },
    headers: {
      Authorization: `bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};

export const getItemsPerCategoryDispatch = (
  id,
  stationId,
  adminToCustomer = null,
) => {
  return (dispatch) => {
    getItemsPerCategory(id, stationId, adminToCustomer)
      .then((x) => {
        const items = x.data;
        items.sort(
          (a, b) => a.CategoryFullOrderNumber - b.CategoryFullOrderNumber,
        );
        dispatch({
          type: actionType.SET_PRODUCTS,
          payload: {
            items,
            //: x.data.sort((a, b) => { return a.CategoryFullOrderNumber - b.CategoryFullOrderNumber })
          },
        });
      })
      .catch(() => console.log("error"));
  };
};

let cancelToken;
export const getItemsPerWord = (
  word,
  branch,
  fields,
  isClientView = false,
  addFamily = true,
) => {
  return (dispatch) => {
    if (cancelToken) {
      cancelToken.cancel("Cancelled previous request");
    }

    cancelToken = axios.CancelToken.source();

    dispatch({ type: actionType.RELOED });

    return axios
      .get(`${newApiBaseUrl}/products/search`, {
        headers: {
          Authorization: `Bearer ${localStorage.jwtToken}`,
          "X-Tenant": localStorage.tenant || "hamazon",
        },
        params: {
          q: word,
          branch,
          fields,
          ...(isClientView && { isClientView: true }),
        },
        cancelToken: cancelToken.token,
      })
      .then((res) => {
        const raw = res.data?.results;
        const items = Array.isArray(raw) ? raw : [];

        dispatch({
          type: actionType.SET_PRODUCTS,
          payload: addFamily
            ? { items: { products: items, isFamily: false } }
            : { items },
        });
        dispatch(setBaseProducts(items));
      })
      .catch((err) => {
        if (axios.isCancel(err)) {
          console.log("Request cancelled:", err.message);
        } else {
          console.error("getItemsPerWord error", err);
          dispatch({
            type: actionType.SET_PRODUCTS,
            payload: { items: [] },
          });
          dispatch(setBaseProducts([]));
        }
      });
  };
};

export const UpdateSort = (data, stationId, adminToCustomer) => {
  return (dispatch) => {
    axios
      .put(`${awsUrl}/v1/products/sort`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.jwtToken}`,
        },
      })
      .then((response) => {
        dispatch(
          getItemsPerCategoryDispatch(
            data.CategoryId,
            stationId,
            adminToCustomer,
          ),
        );
      })
      .catch((error) => {
        console.error("Error updating product sort:", error);
        showAlert("עדכון הסדר נכשל, נסה שוב.");
      });
  };
};

export const UpdateProduct = (data) => {
  return axios.put(`${awsUrl}/v1/products`, data, {});
};
export const AddProductToCategory = (slug, productId, stationId) => {
  return (dispatch) => {
    dispatch(setPreload(true));
    const data = {
      productId,
      branch: stationId,
      kind: "append",
    };
    const config = {
      headers: {
        Authorization: `bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
      },
    };

    return axios
      .post(`${newApiBaseUrl}/admin/categories/${slug}/products`, data, config)
      .then((res) => {
        dispatch({
          type: actionType.ADD_NEW_PRODUCT,
          payload: res.data,
        });
        return res;
      })
      .catch((err) => {
        console.error("Full Error Object:", err.response?.data);
        throw err;
      })
      .finally(() => dispatch(setPreload(false)));
  };
};
export const checkProductExistence = (gtin, branch) => {
  const productId = `${gtin}-000`;
  return axios.get(`${newApiBaseUrl}/admin/products`, {
    params: {
      branch: branch,
      productIds: productId,
      fields: "gtin,name,variant",
    },
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};

export const SetImgActive = (Mkt, imgDataId, imgName) => {
  return (dispatch) =>
    axios
      .put(
        `${awsUrl}/v1/products/image`,
        {
          Mkt,
          ImgId: imgDataId,
        },
        {
          headers: {
            Authorization: `bearer ${localStorage.jwtToken}`,
          },
        },
      )
      .then((x) =>
        dispatch({ type: actionType.SET_UPDAATE_SELCED_PRODUCT, imgName }),
      );
};

export const GetImgUrlProduct = (mkt) => {
  return axios.get(`${awsUrl}/v1/products/${mkt}/image`, {
    headers: {
      Authorization: `bearer ${localStorage.jwtToken}`,
    },
  });
};

export const GetProducts = () => {
  return (dispatch) =>
    axios
      .get(`${awsUrl}/v1/products`, {
        headers: {
          Authorization: `bearer ${localStorage.jwtToken}`,
        },
      })
      .then((x) =>
        dispatch({ type: actionType.SET_ALL_SELECTED_PRODUCT, data: x.data }),
      );
};

export const toggleFilter = (id, typeName) => {
  return (dispatch) => {
    dispatch({ type: actionType.TOGGLE_FILTER, payload: { id, typeName } });
  };
};

export const clearFilters = () => {
  return (dispatch) => {
    dispatch({ type: actionType.CLEAR_FILTER });
  };
};

export const clearSearch = () => {
  return (dispatch) => {
    dispatch({ type: actionType.DELETE_SEARCH });
  };
};

export const search = (word) => {
  return (dispatch) => {
    dispatch({ type: actionType.SET_SEARCH_PRODUCT, payload: word.trim() });
  };
};

export const setFilterSort = (bool) => {
  return (dispatch) => {
    dispatch({ type: actionType.SET_FILTER_SORT, payload: bool });
  };
};

export const setSortKey = (key) => ({
  type: actionType.SET_SORT_KEY,
  payload: key,
});

export const getBrandNameById = (brandId) => {
  return axios.get(`${aspNetUrl}Product/GetBrandNameById?brandId=${brandId}`, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

export const setPrice = (branch, gtin, price) => {
  const data = {
    branch,
    gtin,
    price,
    retailer: "Hamazon",
  };

  axios
    .put(`${newApiBaseUrl}/admin/productprices`, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
      },
    })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      console.error(
        "Error updating price:",
        error.response ? error.response.data : error.message,
      );
    });
};

export const setSailPrice = (data) => {
  axios
    .put(`${newApiBaseUrl}/admin/productpromotions`, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
      },
    })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      console.error(
        "Error updating price:",
        error.response ? error.response.data : error.message,
      );
    });
};

// export const getSails = async (branchId) => {
//   try {
//     const response = await axios.get(`${newApiBaseUrl}/admin/promotions`);
//     console.log("response from server", response);
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching data:", error);
//   }
// };

export const getProductsByCategory = (branch, productId) => {
  return (dispatch) => {
    if (!branch || !productId) {
      if (process.env.NODE_ENV !== "production") {
        console.warn("getProductsByCategory skipped: missing params", {
          branch,
          productId,
        });
      }
      return;
    }
    axios
      .get(`${newApiBaseUrl}/admin/products`, {
        params: {
          branch: branch,
          productIds: productId,
          fields:
            "product_id,gtin,name,variant,brand,sub_brand,user_company,media,description,kosher_supervision,weight_details,weight_jump,exchange_provider,price_control,view_brand,branch,vat_exempt,pricing,show_out_of_stock,logistics_details,package_quantity,has_expiration_date,expired_management",
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${localStorage.jwtToken}`,
          "X-Tenant": "hamazon",
        },
      })
      .then((x) => {
        dispatch({
          type: actionType.SET_PRODUCT_PRICING,
          data: { Product: x.data[0].pricing },
        });
        dispatch({
          type: actionType.SET_SELCTED_PRODUCT,
          data: { Product: x.data[0] },
        });
        dispatch({
          type: actionType.SET_PRODUCT_CATEGORIES,
          data: x.data[0].categories,
        });
      })
      .catch(() => console.log("error"));
  };
};

export const setProducts = (products) => {
  return (dispatch) => {
    dispatch({ type: actionType.SET_PRODUCTS, payload: { items: products } });
  };
};

export const updateProductFields = (branch, productId, tochange) => {
  const data = {
    branch: branch,
    ...tochange,
  };
  return axios.put(`${newApiBaseUrl}/admin/products/${productId}`, data, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};

export const getProductByGtin = (gtin, branch, isClientView = false) => {
  return (dispatch) => {
    if (cancelToken) {
      cancelToken.cancel("Cancelled previous request");
    }
    cancelToken = axios.CancelToken.source();

    dispatch({ type: actionType.RELOED });

    return axios
      .get(`${newApiBaseUrl}/admin/products`, {
        headers: {
          Authorization: `Bearer ${localStorage.jwtToken}`,
          "X-Tenant": "hamazon",
        },
        params: { gtin, branch, ...(isClientView && { isClientView: true }) },
        cancelToken: cancelToken.token,
      })
      .then((res) => {
        const itemsWithCategory = res.data.filter(
          (item) =>
            Array.isArray(item.categories) && item.categories.length > 0,
        );

        dispatch({
          type: actionType.SET_PRODUCTS,
          payload: {
            items: {
              products: itemsWithCategory,
              isFamily: false,
            },
          },
        });

        if (itemsWithCategory[0]?.categories) {
          dispatch({
            type: actionType.SET_PRODUCT_CATEGORIES,
            data: itemsWithCategory[0].categories,
          });
        }
      })
      .catch((err) => {
        if (axios.isCancel(err)) {
          console.log("Request cancelled:", err.message);
        } else {
          console.error("getProductByGtin error", err);

          dispatch({
            type: actionType.SET_PRODUCTS,
            payload: {
              items: {
                products: [],
                isFamily: false,
              },
            },
          });
        }
      });
  };
};

export const getProductByProductsIds = (productsIds, branch) => {
  return axios.get(`${newApiBaseUrl}/admin/products`, {
    params: {
      branch: branch,
      productIds: productsIds,
      fields:
        "product_id,gtin,name,variant,brand,sub_brand,user_company,media,description,kosher_supervision,weight_details,weight_jump,exchange_provider,price_control,view_brand,branch,vat_exempt,pricing,show_out_of_stock,logistics_details",
    },
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};

export const changeProdRank = (slug, productId, data) => {
  return axios.patch(
    `${newApiBaseUrl}/admin/categories/${slug}/products/${productId}`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
      },
    },
  );
};

export const updateProductStatus = (productId, slug, status, branch) => {
  console.log("Updating product status:", { productId, slug, status });

  return axios.put(
    `${newApiBaseUrl}/products/${productId}/${slug}/update-status`,
    { status, branch },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
      },
    },
  );
};

export const getProducts = async (stationId, filters) => {
  const res = await axios.get(`${newApiBaseUrl}/admin/products`, {
    headers: {
      Authorization: `Bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
    params: {
      branch: stationId,
      ...filters,
      fields:
        "product_id,gtin,name,variant,brand,sub_brand,user_company,media,description,kosher_supervision,weight_details,weight_jump,exchange_provider,price_control,view_brand,branch,vat_exempt,pricing,show_out_of_stock,logistics_details",
    },
  });

  return res.data;
};

export const createNewProduct = async ({ gtin, data }) => {
  try {
    const res = await axios.post(
      `${newApiBaseUrl}/admin/products/${gtin}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.jwtToken}`,
          "X-Tenant": "hamazon",
          "Content-Type": "application/json",
        },
      },
    );
    return res;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getUncategorizedProducts = async (stationId) => {
  const response = await axios.get(
    `${newApiBaseUrl}/admin/products/uncategorized`,
    {
      params: {
        branch: stationId,
        fields:
          "product_id,gtin,name,variant,status,brand,sub_brand,user_company,description,kosher_supervision,weight_details,weight_jump",
      },
      headers: {
        "x-tenant": "hamazon",
        Authorization: `Bearer ${localStorage.jwtToken}`,
      },
    },
  );

  return response.data;
};

export const getProductsByStatus = async (branch, filters, page, limit) => {
  const res = await axios.get(
    `${newApiBaseUrl}/productsBystatus?${page ? `page=${page}` : ""}${limit ? `${page ? "&" : ""}limit=${limit}` : "limit=4000"}`,
    {
      params: {
        branch,
        ...filters,
        fields:
          "product_id,gtin,name,variant,status,brand,sub_brand,user_company,description,kosher_supervision,weight_details,weight_jump",
      },
      headers: {
        "x-tenant": "hamazon",
        Authorization: `Bearer ${localStorage.jwtToken}`,
      },
    },
  );
  return res.data.items;
};

export const archiveProduct = (productId, branch) => {
  return axios.post(
    `${newApiBaseUrl}/admin/products/${productId}/archive`,
    {},
    {
      params: {
        branch,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
      },
    },
  );
};
